"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = _interopRequireDefault(require("../../components/Alert/index"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A AlertNotification component
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.ReactElement} A AlertNotification
 */
function AlertNotification(props) {
  if (!props || !props.data) return null;
  var alerts = [];
  props.data.map((alert, index) => {
    alerts.push(/*#__PURE__*/_react.default.createElement(_index.default, {
      key: index,
      index: index,
      item: alert.item,
      env: props.params.env
    }));
  });

  //Removed header. Updates required once BP fixes alert to make it sticky.   
  return /*#__PURE__*/_react.default.createElement("div", null, alerts);
}
var _default = exports.default = AlertNotification;